import { UsersStore, usersStore } from './users.store';
import { UsersState } from './users.model';
import { Query } from '@datorama/akita';

export class UsersQuery extends Query<UsersState> {
  constructor(protected store: UsersStore) {
    super(store);
  }
}

export const usersQuery = new UsersQuery(usersStore);